import {
  Box,
  Button,
  Card,
  CardBody,
  Container,
  Heading,
  List,
  ListIcon,
  ListItem,
  SimpleGrid,
  Text,
  VStack,
} from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router-dom'
import { FiCheckCircle } from 'react-icons/fi'

const modes = [
  {
    title: 'Редактирование (без времени)',
    text: 'Планирование по дням — базовый и самый частый формат работы.',
  },
  {
    title: 'Редактирование (с временем)',
    text: 'Точный режим для задач, где критичны часы начала и окончания.',
  },
  {
    title: 'Просмотр (без времени)',
    text: 'Для сотрудников, которым нужно видеть план без права редактирования.',
  },
  {
    title: 'Просмотр (с временем)',
    text: 'Контроль детального почасового плана без внесения изменений.',
  },
]

export const SchedulePage: React.FC = () => {
  return (
    <Container maxW="container.xl" py={8}>
      <VStack align="stretch" spacing={7}>
        <Box>
          <Heading as="h1" size="2xl" color="brand.600" mb={3}>
            📅 График работ
          </Heading>
          <Text color="gray.600" fontSize="lg">
            Центральный раздел сервиса: планирование, контроль выполнения и
            синхронизация задач между объектами и бригадами.
          </Text>
        </Box>

        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
          {modes.map((mode, idx) => (
            <Card key={mode.title}>
              <CardBody>
                <Text fontSize="sm" fontWeight="700" color="brand.600" mb={2}>
                  Режим {idx + 1}
                </Text>
                <Heading size="sm" mb={2}>{mode.title}</Heading>
                <Text color="gray.600">{mode.text}</Text>
              </CardBody>
            </Card>
          ))}
        </SimpleGrid>

        <Card>
          <CardBody>
            <Heading size="sm" mb={3}>Рекомендованный порядок работы</Heading>
            <List spacing={2}>
              <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Проверьте период (начало и конец).</ListItem>
              <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Выберите правильный режим: редактирование или просмотр.</ListItem>
              <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Внесите изменения и проверьте итоговый вид графика.</ListItem>
              <ListItem><ListIcon as={FiCheckCircle} color="green.500" />При работе по часам включите настройку времени в разделе «Настройки и отчёты».</ListItem>
            </List>
          </CardBody>
        </Card>

        <Box>
          <Heading size="md" mb={3}>Связанные разделы</Heading>
          <Button as={RouterLink} to="/settings" mr={3} variant="outline">Настройки и отчёты</Button>
          <Button as={RouterLink} to="/objects-and-blocks" variant="outline">Объекты и блоки</Button>
        </Box>
      </VStack>
    </Container>
  )
}
